import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

//CREATE PRODUCT

export const addToWishlist = createAsyncThunk(
  "client/crate-product",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/webapp/wishlist/api/v1/add-wishlist`,
        data,
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      console.log("add to Wishlist  response ", response);
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error add to wishlist :", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "error in add to wishlist product"
      );
    }
  }
);

// DELETE PRODUCT

export const deleteFromWishlist = createAsyncThunk(
  "client/delete-product",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/webapp/wishlist/api/v1/wishlist-remove/`,
        data,
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      console.log("delete from wishlist  response ", response);
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error delete from wishlist :", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "error in delete from wishlist product"
      );
    }
  }
);
